/** Default HTTP method for webhook actions */
export const DEFAULT_WEBHOOK_METHOD = 'POST'
